import React from 'react';

const ItemReceiptPrint = ({ item, itemIndex, customer, moduleRef, transactionDate, transactionId }) => {
  if (!item) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const fmt = (amount) => (parseFloat(amount) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const isOldGold = item.gross_wt || item.gross_weight || item.old_gold_gross_wt;

  const row = (label, value) => value ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1px' }}>
      <span>{label}:</span><span style={{ fontWeight: '900' }}>{value}</span>
    </div>
  ) : null;

  return (
    <div
      id={`item-receipt-${itemIndex}`}
      style={{ fontFamily: "'Courier New', monospace", fontSize: '11px', lineHeight: '1.2', color: '#000', fontWeight: '700', padding: '2mm', width: '74mm', maxWidth: '74mm', margin: '0 auto', display: 'block' }}
      className="receipt-page-break"
    >
      {/* Header */}
      <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '2px', marginBottom: '3px' }}>
        <div style={{ fontSize: '13px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          {isOldGold ? 'OLD GOLD RECEIPT' : 'METAL CREDIT RECEIPT'}
        </div>
        <div style={{ fontSize: '10px' }}>#{itemIndex + 1} | {formatDate(transactionDate || new Date())}</div>
      </div>

      {/* Customer */}
      <div style={{ borderBottom: '1px dashed #000', paddingBottom: '2px', marginBottom: '3px' }}>
        {row('Name', customer?.name || 'N/A')}
        {customer?.mobile && row('Mobile', customer.mobile)}
        {moduleRef && row('Ref', moduleRef)}
        {transactionId && row('ID', transactionId)}
      </div>

      {/* OLD GOLD */}
      {isOldGold && (
        <div style={{ border: '2px solid #000', padding: '2px', marginBottom: '3px' }}>
          <div style={{ textAlign: 'center', fontWeight: '900', fontSize: '11px', borderBottom: '1px solid #000', marginBottom: '2px', textTransform: 'uppercase' }}>OLD GOLD DETAILS</div>
          {row('Gross Wt', (item.gross_wt || item.gross_weight || item.old_gold_gross_wt) && `${item.gross_wt || item.gross_weight || item.old_gold_gross_wt}g`)}
          {row('Less Wt', (item.less_wt || item.old_gold_less_wt) && `${item.less_wt || item.old_gold_less_wt}g`)}
          {row('Net Wt', (item.net_wt || item.net_weight || item.old_gold_net_wt) && `${item.net_wt || item.net_weight || item.old_gold_net_wt}g`)}
          {row('Purity', (item.purity || item.old_gold_purity) && `${item.purity || item.old_gold_purity}%`)}
          {row('Fine Gold', (item.fine_wt || item.fine_gold || item.old_gold_fine_wt) && `${item.fine_wt || item.fine_gold || item.old_gold_fine_wt}g`)}
          {row('Rate', (item.rate || item.old_gold_rate) && `₹${fmt(item.rate || item.old_gold_rate)}/g`)}
          {row('Value', (item.value || item.old_gold_value) && `₹${fmt(item.value || item.old_gold_value)}`)}
          {(item.description || item.old_gold_items) && (
            <div style={{ borderTop: '1px dashed #000', marginTop: '2px', paddingTop: '2px' }}>
              <div>Desc: {item.description || item.old_gold_items}</div>
            </div>
          )}
        </div>
      )}

      {/* METAL CREDIT */}
      {!isOldGold && (
        <div style={{ border: '2px solid #000', padding: '2px', marginBottom: '3px' }}>
          <div style={{ textAlign: 'center', fontWeight: '900', fontSize: '11px', borderBottom: '1px solid #000', marginBottom: '2px', textTransform: 'uppercase' }}>METAL CREDIT DETAILS</div>
          {item.deposits && Array.isArray(item.deposits) ? (
            item.deposits.map((dep, idx) => (
              <div key={idx} style={{ marginBottom: idx < item.deposits.length - 1 ? '3px' : 0, paddingBottom: idx < item.deposits.length - 1 ? '3px' : 0, borderBottom: idx < item.deposits.length - 1 ? '1px dashed #000' : 'none' }}>
                <div style={{ fontWeight: '900', fontSize: '10px', textTransform: 'uppercase' }}>Deposit {idx + 1}{dep.item_name && `: ${dep.item_name}`}</div>
                {row('Type', dep.type_name_other || dep.type)}
                {row('Gross Wt', dep.gross_wt && `${dep.gross_wt}g`)}
                {row('Less Wt', dep.less_wt && `${dep.less_wt}g`)}
                {row('Net Wt', dep.net_wt && `${dep.net_wt}g`)}
                {row('Purity', (dep.purity || dep.purity_label) && (dep.purity_label || `${dep.purity}%`))}
                {row('Fine Wt', dep.fine_wt && `${dep.fine_wt}g`)}
              </div>
            ))
          ) : (
            <>
              {row('Type', item.type_name_other || item.type || item.metal_type)}
              {row('Gross Wt', item.gross_wt && `${item.gross_wt}g`)}
              {row('Less Wt', item.less_wt && `${item.less_wt}g`)}
              {row('Net Wt', (item.net_wt || item.metal_weight || item.weight) && `${item.net_wt || item.metal_weight || item.weight}g`)}
              {row('Purity', (item.purity || item.purity_label) && (item.purity_label || `${item.purity}%`))}
              {row('Fine Wt', (item.fine_wt || item.fine_grams) && `${item.fine_wt || item.fine_grams}g`)}
            </>
          )}
        </div>
      )}

      {/* Footer */}
      <div style={{ borderTop: '2px solid #000', paddingTop: '2px', textAlign: 'center', fontSize: '10px' }}>
        <div style={{ fontWeight: '900', marginBottom: '4mm' }}>DEPOSIT WITH CASHIER</div>
        <div style={{ borderBottom: '1px solid #000', width: '45mm', margin: '0 auto', height: '7mm' }}></div>
        <div style={{ marginTop: '1px', fontSize: '10px', fontWeight: '900' }}>AUTHORIZED SIGNATURE</div>
      </div>
    </div>
  );
};

export default ItemReceiptPrint;
